export default __webpack_public_path__ + "static/media/pear.db7892ec.svg";